import http from './api'

const route = 'app/mixcliente2/'

export default {
  showDadosProdutos: (dataInicial, dataFinal, empresaSelect, vendedores, redes, tokencontrato, receita, cidades, areas, segmento, classificacao) => {
    return http.post(route + 'showDadosProdutos', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      receita: receita,
      cidades: cidades,
      areas: areas,
      segmento: segmento,
      classificacao: classificacao,
    })
  },

  showDadosClientesSemMovimentacao: (dataInicial, dataFinal, empresaSelect, vendedores, redes, clienteIds, produto, tokencontrato, receita, cidades, areas, segmento, classificacao) => {
    return http.post(route + 'showDadosClientesSemMovimentacao', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      redes: redes,
      clienteIds: clienteIds,
      produto: produto,
      tokenContrato: tokencontrato,
      receita: receita,
      cidades: cidades,
      areas: areas,
      segmento: segmento,
      classificacao: classificacao,
    })
  },
}
